import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { TextField } from "components/support";

class FilterView extends Component {
  state = {
    name: ""
  };

  handleField = (field, value) => {
    const { onFilter } = this.props;
    this.setState({ [field]: value }, () => onFilter(this.state));
  };

  render() {
    const { name } = this.state;

    return (
      <Row>
        <Col xs={12} md>
          <TextField
            allowClear
            fullWidth
            label="Filtrar por Nome"
            value={name}
            onChange={(_, value) => this.handleField("name", value)}
          />
        </Col>
      </Row>
    );
  }
}

export default FilterView;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/optional-groups/filter/index.jsx